import { Star, TrendingUp, TrendingDown } from 'lucide-react';
import { CombinedSignal, Signal } from '../data/mockData';

interface SignalCardProps {
  signal: Signal | CombinedSignal;
}

export default function SignalCard({ signal }: SignalCardProps) {
  const { stock, signalStrength } = signal;
  const signalTypes = 'signalTypes' in signal ? signal.signalTypes : [signal.signalType];
  const isPositive = stock.changePercent >= 0;

  return (
    <div className="bg-card rounded-xl p-4 shadow-[0_2px_8px_rgba(0,0,0,0.1)] border border-border">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-semibold">{stock.name}</span>
            {stock.topic && (
              <span className="text-xs px-2 py-0.5 bg-[#1a56db]/10 text-[#1a56db] rounded">
                {stock.topic}
              </span>
            )}
          </div>
          <span className="text-xs text-muted-foreground">{stock.code}</span>
        </div>
        <div className={`flex items-center gap-1 px-2 py-1 rounded ${
          isPositive ? 'bg-[#dc3545]/10 text-[#dc3545]' : 'bg-[#28a745]/10 text-[#28a745]'
        }`}>
          {isPositive ? (
            <TrendingUp className="w-3 h-3 text-[#dc3545]" />
          ) : (
            <TrendingDown className="w-3 h-3 text-[#28a745]" />
          )}
          <span className="text-sm font-medium">{isPositive ? '+' : ''}{stock.changePercent.toFixed(2)}%</span>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <div className="text-xs text-muted-foreground mb-1">信号类型</div>
          <div className="flex flex-wrap gap-1.5">
            {signalTypes.map((type, index) => (
              <span 
                key={index} 
                className="text-sm font-medium bg-secondary px-1.5 py-0.5 rounded text-secondary-foreground"
              >
                {type}
              </span>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              className={`w-4 h-4 ${
                i < signalStrength ? 'fill-[#ffc107] text-[#ffc107]' : 'text-muted'
              }`}
            />
          ))}
        </div>
      </div>
      
      <div className="flex justify-between mt-3 text-xs text-muted-foreground border-t border-border pt-2">
        <span>信号日期: {stock.signalDate || '-'}</span>
        <span>数据日期: {stock.dataDate || '-'}</span>
      </div>
    </div>
  );
}
